import { KYMW9000Component } from './kymw9000.component';
import { UserIDModel } from './vo/user-id.model';

/**
 * ユーザ管理画面の値を管理するクラス
 *
 * @export KYMW9000Model
 * @class KYMW9000Model
 */
export class KYMW9000Model {

  kymw9000Component: KYMW9000Component;

  public vo: KYMW9000Model;

  /** 権限リスト */
  public authoritySetList: Array<any> = new Array<any>();

  /** 関連会社ユーザリスト */
  public associatedUserManagementList: Array<any> = new Array<any>();

  /** ユーザ区分コンボボックス */ 
  public associatedUserTypeList: Array<any> = new Array<any>();

  /** ユーザID */ 
  public associatedUserId: string = <string>'';

  /**
   * ユーザ区分(1:取引先（卸）、2:スタジオ、3:制作会社）
   * 初期値 空欄
   */ 
  public associatedUserType: string = <string>'';

  /** 氏名 */
  public associatedUserName: string = <string>'';

  /** メールアドレス */ 
  public emailAddress: string = <string>'';

  /** 権限セットID */
  public authoritySetId: string = <string>'';

  /** 所属名（関連会社名 or 取引先名）*/ 
  public associatedCompanyName: string = <string>'';

  /**
   * 有効/無効区分(0:有効、1:無効、99:すべて)
   * 初期値 99:すべて
   */
  public isEnabled: string = <string>'99';

  /** ページ */
  public page: number = Number(1);

  /** 検索結果合計数 */
  public TotalNum = Number(0);
  /** 検索結果 件数 start */
  public StartDispNum = Number(0);
  /** 検索結果 件数 end　*/
  public EndDispNum = Number(0);

  // ボタンの活性非活性制御用
  public btnBackEnabled = Boolean(false);
  public btnNextEnabled = Boolean(false);
  public btnRegistEnabled = Boolean(true);


  /**
   * 権限セットコンボボックスにレスポンスデータを設定する
   *
   * @param {*} serverData サーバから受信したデータ
   * @memberof KYMW9000Model
   */
  public updateAuthoritySetList(serverData: any): void {
    // 作業用配列
    const tempAuthoritySetList: Array<any> = new Array<any>();

    let authoritySetInfo: any;

    // 権限セットが取得できない場合は、空のArrayCollectionを設定する
    if (serverData != null) {
      // サーバから受信したデータがArrayCollectionであれば複数データとして対応する
      if (serverData.AuthoritySetList instanceof Array) {
        for (let i = Number(0); i < serverData.AuthoritySetList.length; i++) {
          // 権限セットを生成し、作業用配列に追加
          authoritySetInfo = [];
          authoritySetInfo.authoritySetId = serverData.AuthoritySetList[i].AuthoritySetId;
          authoritySetInfo.authoritySetName = serverData.AuthoritySetList[i].AuthoritySetName;
          tempAuthoritySetList.push(authoritySetInfo);
        }
      } else {
        // 権限セットを生成し、作業用配列に追加
        authoritySetInfo = [];
        authoritySetInfo.authoritySetId = serverData.AuthoritySetList[0].AuthoritySetID;
        authoritySetInfo.authoritySetName = serverData.AuthoritySetList[0].AuthoritySetName;
        tempAuthoritySetList.push(authoritySetInfo);
      }
    }

    // 作業用配列をListに設定する
    this.authoritySetList = tempAuthoritySetList;
  }

  /**
   * ユーザ区分コンボボックスにレスポンスデータを設定する
   */
  public updateUserTypeCombobox(serverData: any):void {
    const tempUserTypeList: Array<any> = new Array<any>();
    let userTypeInfo: any = null;
    if (serverData !== null) {
      if (serverData.AssociatedUserTypeList.length > 0) {
        for (let i = Number(0); i < serverData.AssociatedUserTypeList.length; i++) {
          userTypeInfo = [];
          userTypeInfo.associatedUserType = serverData.AssociatedUserTypeList[i].AssociatedUserType;
          userTypeInfo.associatedUserTypeName = this.nullTOEmpty(serverData.AssociatedUserTypeList[i].AssociatedUserTypeName);
          tempUserTypeList.push(userTypeInfo);
        }
      } else {
        userTypeInfo = [];
        userTypeInfo.associatedUserType = '';
        userTypeInfo.associatedUserTypeName = '';
      }
    }
    this.associatedUserTypeList = tempUserTypeList;
  }

  /**
   * ユーザ一覧DataGridにレスポンスデータを設定する
   *
   * @param {*} serverData サーバから受信したデータ
   * @memberof KYMW9000Model
   */
  public updateAssociatedUserManagementList(serverData: any): void {

    // 作業用配列
    const tempAssociatedUserList: Array<any> = new Array<any>();
    let userInfo: any = null;

    if (serverData != null) {
      const associatedUserList = serverData.AssociatedUserList;
      if (associatedUserList.length > 0) {
        for (let i = Number(0); i < associatedUserList.length; i++) {
          // ユーザー情報を作成し、作業用配列に追加
          userInfo = [];
          // ユーザID
          userInfo.associatedUserId = this.nullTOEmpty(associatedUserList[i].AssociatedUserId);
          // ユーザ区分名
          userInfo.associatedUserTypeName = associatedUserList[i].AssociatedUserTypeName;
          // 氏名
          userInfo.associatedUserName = this.nullTOEmpty(associatedUserList[i].AssociatedUserName);
          // メールアドレス
          userInfo.emailAddress = this.nullTOEmpty(associatedUserList[i].EmailAddress);
          // 権限名
          userInfo.authoritySetName = this.nullTOEmpty(associatedUserList[i].AuthoritySetName);
          // 所属名
          userInfo.associatedCompanyName = this.nullTOEmpty(associatedUserList[i].AssociatedCompanyName);
          // 有効/無効
          if ( associatedUserList[i].IsEnabled === '0' ) {
            userInfo.isEnabled = '有効';
          } else if ( associatedUserList[i].IsEnabled === '1' ) {
            userInfo.isEnabled = '無効';
          }

          tempAssociatedUserList.push(userInfo);
        }
      }

      //  ページング設定
      this.TotalNum = Number(serverData.TotalNum);	        //  総件数
      this.StartDispNum = Number(serverData.StartDispNum);	//  開始件数
      this.EndDispNum = Number(serverData.EndDispNum);	    //  終了件数

      // ボタン制御
      this.btnNextEnabled = (this.TotalNum > this.EndDispNum) ? true : false;
      this.btnBackEnabled = (this.StartDispNum > 1) ? true : false;      
    }

    // 作業用配列をListに設定する
    this.associatedUserManagementList = tempAssociatedUserList;
  }

  /**
   * ユーザーID保持用VOを生成する
   *
   * @returns {UserIDModel} ユーザーID保持用VO
   * @memberof KYMW9000Model
   */
  public createUserIDVO(): UserIDModel {
    // 戻り値用VOの定義
    const vo: UserIDModel = new UserIDModel();
    vo.associatedUserId = this.kymw9000Component.getSelectedUserID();
    return vo;
  }

  /**
   * NULLデータを表示用に空白に変換
   *
   * @private
   * @param {*} obj
   * @returns {*}
   * @memberof KYMW9000Model
   */
  private nullTOEmpty(obj: any): any {
    if (obj == null) {
      return '';
    } else if (obj === '0') {
      return '';
    } else {
      return obj;
    }
  }

}
